module.exports = {
  removeFromCart: function(xhr) {
    $('body').trigger('gtm:eec:removeFromCart', xhr.responseJSON);
  }
}